import React from 'react';
import { Box, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Article } from "../../api/types";
import { useArticleCardStyles } from "./ArticleCard.styles";
import { formatDate } from "../../utils/formatDate";
import { useI18n } from "../../i8n/useI18n";

interface ArticleCardProps {
    article: Article;
}

const ArticleCard = (props: ArticleCardProps) => {
    const { classes } = useArticleCardStyles();
    const { t } = useI18n();
    const { article } = props;

    return (
        <Box component={RouterLink} to={`/blog/${article.handle}`} className={classes.root}>
            <Box className={classes.imageWrapper}>
                {article.image && (
                    <Box
                        component="img"
                        src={article.image.url}
                        alt={article.image.altText ?? article.title}
                        className={classes.image}
                        loading="lazy"
                    />
                )}
            </Box>
            <Typography className={classes.category}>{article.tags[0]}</Typography>
            <Typography variant="h6" className={classes.title}>{article.title}</Typography>
            <Typography variant="body2" className={classes.excerpt}>{article.excerpt}</Typography>
            <Typography className={classes.meta}>
                {formatDate(article.publishedAt)} · {article.readingMinutes} {t("blogArticlePage.minuteReadLabel")}
            </Typography>
        </Box>
    );
};

export default ArticleCard;
